import React, { useEffect, useState } from "react";
import { Modal } from "../../../TrueUI";
import { ModalWrapperOfficersProps } from "./TypesInsuredOfficers";
import { useApiGet, useApiPost } from "../../../../hooks";
import {
  isAPITotallyComplete,
  isAPITotallyCompleteNoContentResponse,
} from "../../../../utilities/apiFunctions";
import { InsuredInformationOfficerDto } from "../../../../dtos/insured-information-officer-dto";
import FormInsuredOfficerWrapper from "./FormInsuredOfficerWrapper";
import { StatusEnums } from "../../../../dtos/status-enums";

const INSURED_INFORMATION_API_PATH = "api/InsuredInformation";

const ModalWrapperOfficers: React.FC<ModalWrapperOfficersProps> = ({
  modalConfiguration,
  setModalConfiguration,
}) => {
  const [errorDetails, setErrorDetails] = useState<any>(null);
  const [officer, setOfficer] =
    useState<Partial<InsuredInformationOfficerDto> | null>(null);

  const { dispatchGet, responseGet } = useApiGet<InsuredInformationOfficerDto>(
    `${INSURED_INFORMATION_API_PATH}/GetInsuredInformationOfficerById?officerId=${modalConfiguration?.officerId}`
  );
  const { responsePost, dispatchPost, validatorErrorResponse } = useApiPost(
    `${INSURED_INFORMATION_API_PATH}/SaveInsuredInformationOfficer`,
    officer
  );

  useEffect(() => {
    if (modalConfiguration?.officerId !== null) {
      dispatchGet();
    }
  }, [modalConfiguration?.officerId]);

  useEffect(() => {
    if (modalConfiguration?.isOpen === false) {
      setErrorDetails(null);
    }
  }, [modalConfiguration?.isOpen]);

  useEffect(() => {
    if (isAPITotallyComplete(responseGet)) {
      setOfficer({
        ...(responseGet.responseData ?? null),
        insuredId: modalConfiguration.insuredId,
      });
    }
  }, [responseGet]);

  useEffect(() => {
    if (isAPITotallyCompleteNoContentResponse(responsePost)) {
      setModalConfiguration({
        ...modalConfiguration,
        refreshOfficerComponents: true,
        isOpen: false,
        officerId: null,
      });
      setOfficer(null);
    }
  }, [responsePost]);

  useEffect(() => {
    if (validatorErrorResponse) {
      setErrorDetails(validatorErrorResponse?.errorDetails);
    }
  }, [validatorErrorResponse]);

  useEffect(() => {
    if (officer?.officerStatus === StatusEnums.DELETED) {
      dispatchPost();
    }
  }, [officer?.officerStatus]);

  return (
    <Modal
      id="modal-insured-officers"
      open={modalConfiguration?.isOpen ?? false}
      title="Insured Officers"
      cancelEvent={() =>
        setModalConfiguration({
          ...modalConfiguration,
          isOpen: false,
          officerId: null,
        })
      }
      saveEvent={() => dispatchPost()}
      cancelButtonWithConfirmation
      showCloseButton
      showCancelTextButton
      cancelButtonConfirmationText={
        "Are you sure you want to cancel? Your work will be lost."
      }
      deleteEvent={() => {
        setOfficer({ ...officer, officerStatus: StatusEnums.DELETED });
      }}
      deleteDisabled={false || (modalConfiguration?.officerId ?? 0) === 0}
      deleteButtonWithConfirmation
      size="sm"
    >
      <FormInsuredOfficerWrapper
        officer={officer}
        setOfficer={setOfficer}
        errors={errorDetails}
        insuredInformationApiPath={INSURED_INFORMATION_API_PATH}
      />
    </Modal>
  );
};

export default ModalWrapperOfficers;
